<template>
  <div>
    <div class="navbar">
      <div class="navbar__section">
        <li :class="['navbar__item', 'dashboard', { expanded: expanded }]">
          <Tooltip
            black-theme
            :disabled="expanded"
            :label="$t('customer.nav.dashboard.title')"
          >
            <router-link
              class="navbar__item__link--dashboard"
              :to="{ name: 'clientProgressOnboarding' }"
              :class="{ expanded: expanded }"
            >
              <span class="navbar__item__link--container--dashboard">
                <Logo :with-text="expanded" />
              </span>
            </router-link>
          </Tooltip>
        </li>
        <li :class="['navbar__item', { expanded: expanded }]">
          <Tooltip
            black-theme
            :disabled="expanded"
            :label="$t('customer.nav.overview.btn')"
          >
            <router-link
              class="navbar__item__link"
              :to="{ name: 'clientOverview' }"
              :class="{
                'router-link-active': baseRoute === 'clientOverview',
                expanded: expanded
              }"
            >
              <span class="navbar__item__link--container">
                <InlineSvg
                  class="navbar__item__link--icon"
                  :src="
                    baseRoute === 'clientOverview'
                      ? require('@/assets/icons/navbar/active/overview.svg')
                      : require('@/assets/icons/navbar/default/overview.svg')
                  "
                  alt="dot"
                  width="20"
                />
              </span>
              <TextRegular v-if="expanded" semi-bold>
                {{ $t('customer.nav.overview.btn') }}
              </TextRegular>
            </router-link>
          </Tooltip>
        </li>
        <li :class="['navbar__item', { expanded: expanded }]">
          <Tooltip
            black-theme
            :disabled="expanded"
            :label="$t('shared.caas.title')"
          >
            <router-link
              class="navbar__item__link"
              :to="{ name: 'contentGenerationV2' }"
              :class="{
                'router-link-active': baseRoute === 'contentGenerationV2',
                expanded: expanded
              }"
            >
              <span class="navbar__item__link--container">
                <InlineSvg
                  class="navbar__item__link--icon"
                  :src="
                    baseRoute === 'contentGenerationV2'
                      ? require('@/assets/icons/navbar/active/content-generation.svg')
                      : require('@/assets/icons/navbar/default/content-generation.svg')
                  "
                  alt="dot"
                  width="20"
                />
              </span>
              <TextRegular v-if="expanded" semi-bold>
                {{ $t('shared.caas.title') }}
              </TextRegular>
            </router-link>
          </Tooltip>
        </li>
        <li
          v-if="showContentPillars"
          :class="['navbar__item', { expanded: expanded }]"
        >
          <Tooltip
            black-theme
            :disabled="expanded"
            :label="$t('shared.label.content_pillars')"
          >
            <router-link
              class="navbar__item__link"
              :to="{ name: 'clientPillarsOverview' }"
              :class="{
                'router-link-active': baseRoute === 'clientPillars',
                expanded: expanded
              }"
            >
              <span class="navbar__item__link--container">
                <InlineSvg
                  class="navbar__item__link--icon"
                  :src="
                    baseRoute === 'clientPillars'
                      ? require('@/assets/icons/navbar/active/seo-active.svg')
                      : require('@/assets/icons/navbar/default/seo.svg')
                  "
                  alt="dot"
                  width="20"
                />
              </span>
              <TextRegular v-if="expanded" semi-bold>
                {{ $t('shared.label.content_pillars') }}
              </TextRegular>
            </router-link>
          </Tooltip>
        </li>
        <li :class="['navbar__item', { expanded: expanded }]">
          <Tooltip
            black-theme
            :disabled="expanded"
            :label="$t('customer.nav.automation_flows.btn')"
          >
            <router-link
              class="navbar__item__link"
              :to="{ name: 'clientAutomationFlows' }"
              :class="{
                'router-link-active': baseRoute === 'clientAutomationFlows',
                expanded: expanded
              }"
            >
              <span class="navbar__item__link--container">
                <InlineSvg
                  class="navbar__item__link--icon"
                  :src="
                    baseRoute === 'clientAutomationFlows'
                      ? require('@/assets/icons/navbar/active/automation.svg')
                      : require('@/assets/icons/navbar/default/automation.svg')
                  "
                  alt="dot"
                  width="20"
                />
              </span>
              <TextRegular v-if="expanded" semi-bold>
                {{ $t('customer.nav.automation_flows.btn') }}
              </TextRegular>
            </router-link>
          </Tooltip>
        </li>
        <li :class="['navbar__item', { expanded: expanded }]">
          <Tooltip
            black-theme
            :disabled="expanded"
            :label="$t('customer.nav.libraries.btn')"
          >
            <router-link
              class="navbar__item__link"
              :to="{ name: 'clientLibrariesLayout' }"
              :class="{
                'router-link-active': baseRoute === 'clientLibraries',
                expanded: expanded
              }"
            >
              <span class="navbar__item__link--container">
                <InlineSvg
                  class="navbar__item__link--icon"
                  :src="
                    baseRoute === 'clientLibraries'
                      ? require('@/assets/icons/navbar/active/string-library.svg')
                      : require('@/assets/icons/navbar/default/string-library.svg')
                  "
                  alt="dot"
                  width="20"
                />
              </span>
              <TextRegular v-if="expanded" semi-bold>
                {{ $t('customer.nav.libraries.btn') }}
              </TextRegular>
            </router-link>
          </Tooltip>
        </li>
        <li :class="['navbar__item', { expanded: expanded }]">
          <Tooltip
            black-theme
            :disabled="expanded"
            :label="$t('customer.nav.translators.btn')"
          >
            <router-link
              class="navbar__item__link"
              :to="{ name: 'clientTranslators' }"
              :class="{
                'router-link-active': baseRoute === 'clientTranslators',
                expanded: expanded
              }"
            >
              <span class="navbar__item__link--container">
                <InlineSvg
                  class="navbar__item__link--icon"
                  :src="
                    baseRoute === 'clientTranslators'
                      ? require('@/assets/icons/navbar/active/translators.svg')
                      : require('@/assets/icons/navbar/default/translators.svg')
                  "
                  alt="dot"
                  width="20"
                />
              </span>
              <TextRegular v-if="expanded" semi-bold>
                {{ $t('customer.nav.translators.btn') }}
              </TextRegular>
            </router-link>
          </Tooltip>
        </li>
        <!-- <li :class="['navbar__item', { expanded: expanded }]">
          <Tooltip
            black-theme
            :disabled="expanded"
            :label="$t('customer.translation_assets.custom_mt.title')"
          >
            <router-link
              class="navbar__item__link"
              :to="{ name: 'customMt' }"
              :class="{
                'router-link-active': baseRoute === 'customerAssets',
                expanded: expanded
              }"
            >
              <span class="navbar__item__link--container">
                <InlineSvg
                  class="navbar__item__link--icon"
                  :src="
                    baseRoute === 'customerAssets'
                      ? require('@/assets/icons/navbar/active/mt.svg')
                      : require('@/assets/icons/navbar/default/mt.svg')
                  "
                  alt="dot"
                  width="20"
                />
              </span>
              <TextRegular v-if="expanded" semi-bold>
                {{ $t('customer.nav.translation_assets.btn') }}
              </TextRegular>
            </router-link>
          </Tooltip>
        </li> -->
        <li :class="['navbar__item', { expanded: expanded }]">
          <Tooltip
            black-theme
            :disabled="expanded"
            :label="$t('customer.nav.marketplace.btn')"
          >
            <router-link
              class="navbar__item__link"
              :to="{ name: 'clientMarketplace' }"
              :class="{
                'router-link-active': baseRoute === 'clientMarketplace',
                expanded: expanded
              }"
            >
              <span class="navbar__item__link--container">
                <InlineSvg
                  class="navbar__item__link--icon"
                  :src="
                    baseRoute === 'clientMarketplace'
                      ? require('@/assets/icons/navbar/active/app-marketplace.svg')
                      : require('@/assets/icons/navbar/default/app-marketplace.svg')
                  "
                  alt="dot"
                  width="20"
                />
              </span>
              <TextRegular v-if="expanded" semi-bold>
                {{ $t('customer.nav.marketplace.btn') }}
              </TextRegular>
            </router-link>
          </Tooltip>
        </li>
        <li :class="['navbar__item', { expanded: expanded }]">
          <Tooltip
            black-theme
            :disabled="expanded"
            :label="$t('shared.label.messages')"
          >
            <router-link
              class="navbar__item__link"
              :to="{ name: 'customerChat' }"
              :class="{
                'router-link-active': baseRoute === 'customerChat',
                expanded: expanded
              }"
            >
              <span class="navbar__item__link--container">
                <InlineSvg
                  class="navbar__item__link--icon"
                  :src="
                    baseRoute === 'customerChat'
                      ? require('@/assets/icons/navbar/active/chat.svg')
                      : require('@/assets/icons/navbar/default/chat.svg')
                  "
                  alt="dot"
                  width="20"
                />
              </span>
              <TextRegular v-if="expanded" semi-bold>
                {{ $t('shared.label.messages') }}
              </TextRegular>
            </router-link>
          </Tooltip>
        </li>
      </div>
      <!-- here -->
      <div class="navbar__section">
        <li :class="['navbar__item', { expanded: expanded }]">
          <Tooltip
            black-theme
            :disabled="expanded"
            :label="$t('customer.users_permissions.btn.invite')"
          >
            <a
              class="navbar__item__link"
              :class="{
                expanded: expanded
              }"
              @click="handleInviteModal"
            >
              <span
                v-if="expanded"
                class="navbar__item__link--container navbarItem1"
              >
                <InlineSvg
                  class="navbar__item__link--icon"
                  :src="
                    require('@/assets/icons/navbar/default/user-plus-solid.svg')
                  "
                  alt="dot"
                  width="20"
                  fill="#454a5b"
                />
              </span>

              <span
                v-else
                class="navbar__item__link--container navbarItem2"
              >
                <InlineSvg
                  class="navbar__item__link--icon"
                  :src="
                    require('@/assets/icons/navbar/default/user-plus-solid.svg')
                  "
                  alt="dot"
                  width="20"
                  fill="#454a5b"
                />
              </span>
              <TextRegular v-if="expanded" semi-bold>
                {{ $t('customer.users_permissions.btn.invite') }}
              </TextRegular>
            </a>
          </Tooltip>
        </li>

        <li :class="['navbar__item', { expanded: expanded }]">
          <Tooltip
            black-theme
            :disabled="expanded"
            :label="$t('shared.terms.knowledge_base.title')"
          >
            <a
              class="navbar__item__link"
              href="https://knowledge.easytranslate.com/"
              target="_blank"
              :class="{
                expanded: expanded
              }"
            >
              <span
                v-if="expanded"
                class="navbar__item__link--container navbarItem3"
              >
                <InlineSvg
                  class="navbar__item__link--icon"
                  :src="
                    require('@/assets/icons/navbar/default/lightbulb-regular.svg')
                  "
                  alt="dot"
                  width="16"
                  fill="#454a5b"
                />
              </span>
              <span
                v-else
                class="navbar__item__link--container navbarItem4"
              >
                <InlineSvg
                  class="navbar__item__link--icon"
                  :src="
                    require('@/assets/icons/navbar/default/lightbulb-regular.svg')
                  "
                  alt="dot"
                  width="16"
                  fill="#454a5b"
                />
              </span>
              <TextRegular v-if="expanded" semi-bold>
                {{ $t('shared.terms.knowledge_base.title') }}
              </TextRegular>
            </a>
          </Tooltip>
        </li>

        <li
          v-if="enableUpgrade"
          :class="['navbar__item', { expanded: expanded }]"
          @click="toggleUpgrade"
          @mouseover="upgradeHover = true"
          @mouseleave="upgradeHover = false"
        >
          <Tooltip
            black-theme
            :disabled="expanded"
            :label="$t('customer.upgrade_sub.upgrade')"
          >
            <div
              class="navbar__item__link containerUpgradeLink"
              :class="{ expanded: expanded }"
            >
              <span
                v-if="expanded"
                class="navbar__item__link--container containerUpgrade navbarItem5"
              >
                <InlineSvg
                  class="navbar__item__link--icon kreep upgradeIcon"
                  :src="
                    (showUpgradeSubscriptionModal &&
                      route.params.upgradeUsage == 'true') ||
                    upgradeHover
                      ? require('@/assets/icons/navbar/active/upgrade_hover.svg')
                      : require('@/assets/icons/navbar/default/upgrade_default.svg')
                  "
                  alt="dot"
                  width="20"
                />
              </span>
              <span
                v-else
                class="navbar__item__link--container containerUpgrade"
              >
                <InlineSvg
                  class="navbar__item__link--icon kreep upgradeIcon"
                  :src="
                    (showUpgradeSubscriptionModal &&
                      route.params.upgradeUsage == 'true') ||
                    upgradeHover
                      ? require('@/assets/icons/navbar/active/upgrade_hover.svg')
                      : require('@/assets/icons/navbar/default/upgrade_default.svg')
                  "
                  alt="dot"
                  width="20"
                />
              </span>

              <TextRegular v-if="expanded" semi-bold>
                {{ $t('customer.upgrade_sub.upgrade') }}
              </TextRegular>
            </div>
          </Tooltip>
        </li>
        <li
          :class="[
            'navbar__item',
            'navbar__item--profile',
            { expanded: expanded, active: showProfile }
          ]"
          @click.stop.prevent="toggleProfile"
        >
          <ProfileMenu
            :expanded="expanded"
            :show-profile="showProfile"
            data-cy="profile_menu"
            @logout="logout"
            @toggleProfile="toggleProfile"
          />
          <TextRegular v-if="expanded" semi-bold>
            <p>{{ profileName }}</p>
          </TextRegular>
        </li>
      </div>
    </div>
  </div>
</template>
<script setup>
import { TokenService } from '@/api/new/services/storage.service'
import ProfileMenu from '@/components/navbar/ProfileMenu'
import TextRegular from '@/components/shared/font/text/TextRegular'

import Tooltip from '@/components/shared/tooltip/Tooltip'
import Logo from '@/components/sidebar/Logo'
import i18n from '@/i18n'
import { computed, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

const store = useStore()
const $t = i18n.t
const route = useRoute()
const router = useRouter()

const props = defineProps({
  expanded: Boolean
})

const showProfile = ref(false)
const upgradeHover = ref(false)

const baseRoute = computed(() => store.state.navigation.baseRoute)
const currentUser = computed(() => store.state.workspace.currentUser)
const showUpgradeSubscriptionModal = computed(
  () => store.state.modals.showUpgradeSubscriptionModal
)
const enableUpgrade = computed(() => store.getters['account/enableUpgrade'])

const profileName = computed(() => {
  return `${currentUser.value?.attributes?.first_name || ''} ${
    currentUser.value?.attributes?.last_name || ''
  }`
})

const showContentPillars = computed(() => {
  return process.env.VUE_APP_RELEASE_CONTENT_PILLARS == 'true'
})

const toggleUpgradeSubscriptionModal = () =>
  store.commit('modals/toggleUpgradeSubscriptionModal')
const toggleInviteUserModal = () => store.commit('modals/toggleInviteUserModal')
const setEngStartTime = (payload) =>
  store.commit('workspace/setEngStartTime', payload)
const getStateBilling = () => store.dispatch('payment/getStateBilling')
const getStateTeamUser = (payload) =>
  store.dispatch('teams/getStateTeamUser', payload)
const logoutUser = () => store.dispatch('auth/logoutUser')
const getStateUsersInvitations = () =>
  store.dispatch('invitations/getStateUsersInvitations')
const startLoader = () => store.dispatch('loading/startLoader')
const stopLoader = () => store.dispatch('loading/stopLoader')

async function logout() {
  startLoader()
  try {
    await logoutUser()
    await TokenService.removeAll()
  } finally {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      loginStatus: 'logged out',
      userId: currentUser.value?.attributes?.hash
    })
    stopLoader()
    store.reset()
    router.push({ name: 'BaseLogin' })
  }
}

function toggleProfile() {
  showProfile.value = !showProfile.value
}

async function toggleUpgrade() {
  await getStateBilling()
  await getStateTeamUser(currentUser.value.id)
  setEngStartTime(Date.now())
  toggleUpgradeSubscriptionModal()
  router.replace({
    query: { ...route.query, upgradeSubscriptionStart: true },
    params: { upgradeUsage: true }
  })
}

async function handleInviteModal() {
  startLoader()
  try {
    await getStateUsersInvitations()
    toggleInviteUserModal()
  } finally {
    stopLoader()
  }
}
</script>
<style lang="scss" scoped>
.navbar {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
  padding: 10px 0;
  &__createProject {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &__section {
    &:nth-child(1) {
      display: grid;
      grid-template-rows: 70px repeat(10, 48px);
    }
  }
}

.navbar__section {
  &:nth-child(2) {
    display: grid;
    background-color: #fff;
    .navbar__item {
      &:not(:last-child) {
        :deep() {
          .tooltipContainer {
            .tooltip {
              top: -5% !important;
            }
          }
        }
      }

      &__link {
        cursor: pointer;
        &.expanded {
          margin-top: 5px;
        }
      }
      .containerUpgradeLink {
        padding-right: 0px !important;
        background: #e3f9f2;
        margin-bottom: 10px;
        &.expanded {
          margin-top: 5px;
          margin-bottom: 3px;
        }
      }
      .containerUpgrade {
        &.expanded {
          margin-left: -10px;
          margin-right: 4px;
        }
      }
    }
  }
}

.navbar__item {
  display: flex;
  justify-content: center;
  padding: 0 3px;

  :deep() {
    .tooltipContainer {
      width: 100%;
      margin: 0 5px;
    }
  }
  &:not(:first-child) {
    :deep() {
      .tooltipContainer {
        .tooltip {
          top: -25% !important;
        }
      }
    }
  }
  &.expanded {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    &:not(.dashboard) {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      :deep() {
        .tooltipContainer {
          width: 100%;
          div {
            width: 100% !important;
            flex-direction: row;
            justify-content: flex-start;
          }
        }
      }
    }
  }
  a {
    color: var(--main-grey) !important;
  }
  &--news {
    padding: 15px 0;
    position: relative;
  }
  &--settings {
    padding: 15px 0;
    position: relative;
    &:before {
      content: '';
      width: 20px;
      height: 1px;
      background: #e6e9f0;
      position: absolute;
      top: 0;
    }
    &:after {
      content: '';
      width: 20px;
      height: 1px;
      background: #e6e9f0;
      position: absolute;
      bottom: 0;
    }
    .active-link {
      position: relative;
      &:before {
        content: '';
        height: 100%;
        width: 2px;
        background: $blue-80;
        position: absolute;
        left: -1px;
        border-radius: 5px;
      }
    }
  }
  &--profile {
    border-radius: 6px;
    padding-bottom: 10px;
    cursor: pointer;
    &.expanded {
      padding: 5px;
      margin: 0 3px;
      :deep() {
        .profileMenuContainer {
          margin-left: 0px;
          padding: 0px;
          .profilePhoto {
            margin-left: -1px;
            margin-right: 7px;
            height: 32px;
            width: 32px;
          }
        }
      }
      &:hover,
      &.active {
        color: $blue-80 !important;
        background: $blue-10;
      }
    }
  }
  a {
    cursor: pointer;
  }
  .kreep {
    display: inline-block;
    /*name-duration-function(ease,eas-in,linear)-delay-count-direction */
    animation: kreep 0.7s ease 2s infinite alternate;
  }

  .kreep:hover {
    animation: none !important;
  }
  /*END BOUNCER*/

  //here
  @keyframes kreep {
    0% {
      -webkit-transform: scale(1.1, 0.9);
      transform: scale(1.1, 0.9);
    }
    50% {
      -webkit-transform: scale(0.9, 1.1) translateY(-0.5rem);
    }
    70% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }

  &--upgrade {
    -webkit-transition-duration: 0.4s !important; /* Safari */
    transition-duration: 0.4s !important;
    text-decoration: none;
    text-align: center;
    cursor: pointer;
    margin-bottom: 0.5rem;

    .navbar__item__link {
      padding-right: 0px !important;
      background: #e3f9f2;
      &.expanded {
        margin-bottom: -7px;
        .containerUpgrade {
          &.expanded {
            margin-left: -10px;
            margin-right: 4px;
          }
        }
      }
    }
  }
}

.navbar__item__link {
  width: 100%;
  padding-right: 15px;
  border-radius: 6px;

  .navbarItem1 {
    margin-left: -5px; 
    margin-right: 4px;
  }

  .navbarItem2 {
    margin-bottom: -10px; 
    margin-left: 2px;
  }

  .navbarItem3 {
    margin-left: -7px; 
    margin-right: 6px;
  }

  .navbarItem4 {
    margin-bottom: -10px;
  }

  .navbarItem5 {
    margin-left: -7px; 
    margin-right: 5px;
  }

  .navbar__item__link--container {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2.5px;
    width: 40px;
    height: 40px;

    &:hover {
      &:not(.navbar__item__link--container--dashboard, .containerUpgrade) {
        color: $blue-80 !important;
        background: $blue-10;
      }
    }
  }
  &.router-link-active {
    .navbar__item__link--container {
      background: $blue-30;
      &:before {
        content: '';
        height: 100%;
        width: 4px;
        background: $blue-80;
        position: absolute;
        left: -10px;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
      }
    }
  }
  &.expanded {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    .navbar__item__link--container {
      margin: 0;
    }
    &:hover {
      &:not(.navbar__item__link--dashboard, .containerUpgradeLink) {
        color: $blue-80 !important;
        background: $blue-10;
        border-radius: 6px;
      }
    }
    &.router-link-active {
      background: $blue-30;
      .navbar__item__link--container {
        background: none;
      }
    }
  }
}

.navbar__createProject {
  position: relative;
  margin-bottom: 20px;
  &:after {
    content: '';
    position: absolute;
    width: 20px;
    height: 1px;
    background: #e6e9f0;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }
}

span.icon {
  font-size: 0.8rem !important;
}

.icon__logo {
  height: 40px;
  width: 100%;
  path {
    fill: $blue-80;
  }
  &.with__text {
    margin-top: 5px;
    margin-left: 1px;
    height: 30px;
  }
}
</style>
